module.exports = __webpack_public_path__ + "img/button-icon-lisence.c3a7d2e2.svg";